/* eslint-disable */

import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import dayjs from 'dayjs';
import dayTh from 'dayjs/locale/th';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import BtnGogo from '../../../components/buttongoto/ButtonGoto';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';
import { orderStatus } from '../library';
import { colors } from '../../../helper/constant';

dayjs.extend(buddhistEra);
dayjs.locale(dayTh);

function MyShop_Seller_Payment(props) {
  const [myorder_list, setorder_list] = useState([]);
  const [modal_popup, setModal_popup] = useState({
    modaltype: '',
    headers: '',
    message: '',
    enable: false,
  });

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const view = new URLSearchParams(location.search).get('view');
    if (view === 'all' && props.data_shoporder_seller_all) {
      setorder_list(props.data_shoporder_seller_all);
    } else {
      setorder_list(props.data_shoporder_seller_payment);
    }
  }, [props.data_shoporder_seller_payment, props.data_shoporder_seller_all, location.search]);

  function isTabActive(path) {
    return location.pathname.indexOf(path) > -1;
  }

  function showDialogCallback_General(message) {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  function showDialogCallback_Confirm(message) {}

  return (
    <div className='my-0 font-inter font-th'>
      <div className='row'>
        {myorder_list.length > 0 ? (
          myorder_list.map((order, index0) => (
            <div className='col-md-12 mb-md-2 mb-lg-0 ' key={order.order_id}>
              <div className='card-mycart mb-2'>
                <div className='card-mycart-header modern light-theme'>
                  <div className='modern-header-responsive'>
                    <div className='d-flex align-items-center gap-3'>
                      <div className='bg-white rounded-circle d-flex align-items-center justify-content-center' style={{ width: '40px', height: '40px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)', flexShrink: 0 }}>
                        <i className='font-size-18 fas fa-store text-primary'></i>
                      </div>
                      <div className='d-block'>
                        <div className='card-mycart-title mb-0 font-th'>
                          {order.buyer_shopname}
                        </div>
                        <div className='card-mycart-subtitle font-th'>
                          <i className='fas fa-map-marker-alt mr-1'></i> {order.buyer_shopprovince}
                        </div>
                      </div>
                    </div>
                    <div className='d-flex flex-column align-items-end'>
                      <div className='order-id-label mb-1'>
                        ORD: {order.order_id}
                      </div>
                      {orderStatus(order, 'seller')}
                    </div>
                  </div>
                </div>
              <div className='card-mycart-body'>
                <div className='d-block d-md-flex justify-content-between pt-0 pb-2 flex-wrap'>
                  <div className='d-block'>
                    {order.orderitem !== null
                      ? order.orderitem.map((orderitems, index1) => (
                          <div
                            className={'d-block d-md-flex py-1 ' + (index1 > 0 ? 'border-top' : '')}
                            key={orderitems.orderitem_id}
                          >
                            <div className='d-flex'>
                              <div className='mycart-box-image'>
                                <img
                                  className='img-fluid max-width-100 p-1 border border-color-1'
                                  src={
                                    `${process.env.REACT_APP_IMAGE_URL}` +
                                    orderitems.productitem_id +
                                    '/' +
                                    orderitems.productitem_id +
                                    '-1-' +
                                    orderitems.img1_key +
                                    '.jpg'
                                  }
                                  alt={orderitems.orderitem_id}
                                />
                              </div>
                              <div className='d-block product-detail'>
                                <div className='mycart-box-productname py-0'>
                                  {orderitems.productitem_name}
                                </div>
                                <div className='mycart-box-productinter py-0'>
                                  {orderitems.productitem_inter}
                                </div>
                              </div>
                            </div>
                            <div className='mycart-box-pricelist'>
                              <table>
                                <tbody className='d-block mt-0'>
                                  {orderitems.orderitem_pricelist !== null
                                    ? orderitems.orderitem_pricelist.map((pricelist, index1) => (
                                        <tr
                                          className='mycart-table-pricelist-row py-0'
                                          key={pricelist.pricelist_id}
                                          style={{ paddingTop: '0px' }}
                                        >
                                          <td className='product-unit'>
                                            ชุด {pricelist.unit} ชิ้น
                                          </td>
                                          <td className='product-stock'>
                                            Exp.{' '}
                                            {dayjs(new Date(pricelist.expire)).format(
                                              'DD MMM BBBB',
                                            )}
                                          </td>
                                          <td className='product-quantity'>
                                            x {pricelist.select} ชุด
                                          </td>
                                          <td className='product-subtotal'>
                                            ฿{' '}
                                            {pricelist.subtotal.toLocaleString(undefined, {
                                              maximumFractionDigits: 0,
                                              minimumFractionDigits: 0,
                                            })}
                                          </td>
                                        </tr>
                                      ))
                                    : null}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        ))
                      : null}
                  </div>
                  <div className='d-block mt-2 mb-5 mb-md-2' style={{ minWidth: '250px' }}>
                    <div className='d-flex justify-content-between py-0 border-bottom text-danger'>
                      <div className='table-summary-cell'>ต้องชำระภายใน</div>
                      <div className='table-summary-cell aligh-right'>
                        {dayjs(new Date(order.expiretime))
                          .subtract(7, 'hours')
                          .format('DD MMM BBBB HH:mm')}
                      </div>
                    </div>
                    <div className='d-flex justify-content-between py-0 mt-2'>
                      <div className='table-summary-cell'>มูลค่าสินค้า</div>
                      <div className='table-summary-cellt'>
                        ฿{' '}
                        {Number(order.shop_subtotal).toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                          minimumFractionDigits: 2,
                        })}
                      </div>
                    </div>
                    <div className='d-flex justify-content-between py-0'>
                      <div className='table-summary-cell'>ค่าขนส่ง</div>
                      <div className='table-summary-cell aligh-right'>
                        ฿{' '}
                        {Number(order.shop_shipping_markup).toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                          minimumFractionDigits: 2,
                        })}
                      </div>
                    </div>
                    <div className='d-flex justify-content-between py-0 border-bottom'>
                      <div className='table-summary-cell'>ยอดที่ต้องชำระ</div>
                      <div className='table-summary-cell aligh-right'>
                        ฿{' '}
                        {Number(order.shop_total).toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                          minimumFractionDigits: 2,
                        })}
                      </div>
                    </div>
                    <div className='d-flex justify-content-between py-0 mt-2'>
                      <div className='table-summary-cell'>ค่าธรรมเนียม</div>
                      <div className='table-summary-cell aligh-right'>
                        ฿{' '}
                        {Number(order.shop_servicecharge).toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                          minimumFractionDigits: 2,
                        })}
                      </div>
                    </div>
                    <div className='d-flex justify-content-between py-0 border-bottom text-success'>
                      <div className='table-summary-cell'>ยอดของร้าน</div>
                      <div className='table-summary-cell aligh-right'>
                        ฿{' '}
                        {Number(order.shop_income).toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                          minimumFractionDigits: 2,
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          ))
        ) : (
          <div className='col-md-12'>
            <div className='empty-state-container'>
              <div className='empty-state-icon'>
                <i className='fas fa-receipt'></i>
              </div>
              <div className='empty-state-title font-th'>ไม่มีรายการชำระเงิน</div>
              <div className='empty-state-text font-th'>ยังไม่พบออเดอร์ที่อยู่ในขั้นตอนการชำระเงินในขณะนี้</div>
            </div>
          </div>
        )}
      </div>
      <ModalPopupMessage
        callback_general={(message) => {
          showDialogCallback_General(message);
        }}
        callback_confirm={(message) => {
          showDialogCallback_Confirm(message);
        }}
        options={modal_popup}
      />
      <BtnGogo></BtnGogo>
    </div>
  );
}

export default MyShop_Seller_Payment;
